import { render, staticRenderFns } from "./ProcessForm.vue?vue&type=template&id=6bbf90e5&scoped=true"
import script from "./ProcessForm.ts?vue&type=script&lang=ts&external"
export * from "./ProcessForm.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf90e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bbf90e5')) {
      api.createRecord('6bbf90e5', component.options)
    } else {
      api.reload('6bbf90e5', component.options)
    }
    module.hot.accept("./ProcessForm.vue?vue&type=template&id=6bbf90e5&scoped=true", function () {
      api.rerender('6bbf90e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/ProcessForm/ProcessForm.vue"
export default component.exports